const normalize = value => String(value ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, " ").trim();
export function planningEntity(contract, view) {
  const name = String(view === "worker" ? contract.NomPrenom || "Intérimaire non renseigné" : contract.RaisonSociale || "Client non renseigné").trim();
  const rawId = view === "worker" ? contract.IdInterimaire : contract.IdClient;
  const usableId = ["string", "number"].includes(typeof rawId) && normalize(rawId) !== "" && String(rawId) !== "0";
  return { id: `${view}:${usableId ? `id:${rawId}` : `name:${normalize(name)}`}`, name };
}
// Phone of the client record behind a planning line (contract, request or order).
export function planningClientPhone(contract, clients) {
  const id = contract?.client?._id || contract?.clientId || (typeof contract?.client === "string" ? contract.client : null);
  const name = normalize(contract?.RaisonSociale || contract?.client?.companyName);
  const client = (id && clients.find(c => String(c._id) === String(id)))
    || (contract?.IdClient != null && String(contract.IdClient).trim() && clients.find(c => c.pld != null && String(c.pld) === String(contract.IdClient)))
    || (name && clients.find(c => normalize(c.companyName) === name))
    || contract?.client;
  if (!client || typeof client !== "object") return "";
  const contacts = client.contacts || [];
  const contact = contacts.find(c => c.primary && (c.mobile || c.phone)) || contacts.find(c => c.mobile || c.phone);
  return String(client.phone || client.contactPhone || contact?.mobile || contact?.phone || client.user?.phone || "").trim();
}
export function matchesPlanningSearch(contract, search) {
  const text = normalize([contract.NomPrenom, contract.RaisonSociale, contract.NumeroContrat].join(" "));
  return normalize(search).split(" ").filter(Boolean).every(word => text.includes(word));
}
export function planningOptions(contracts, view) {
  const map = new Map();
  contracts.forEach(contract => { const entity = planningEntity(contract, view); map.set(entity.id, entity); });
  return Array.from(map.values()).sort((a,b) => a.name.localeCompare(b.name, "fr"));
}
